import { makeStyles } from '@material-ui/core/styles';

export type FilterLayoutStyleProps = {
	topOffset: number;
	fileTreeMaxHeight: number;
};

export const useStyles = makeStyles(theme => {
	return {
		showroomFiltersContainer: {
			display: 'flex',
			alignItems: 'flex-start',
			margin: '3.33% 3.5% 0 3.5%'
		},
		showroomFilterTreeContainerWebkit: {
			position: '-webkit-sticky'
		},
		showroomFilterTreeContainer: {
			width: 300,
			marginRight: 35,
			paddingRight: 15,
			paddingLeft: 15,
			marginLeft: -15,
			position: 'sticky',
			top: (props: FilterLayoutStyleProps) => props.topOffset,
			overflow: 'hidden auto',
			maxHeight: (props: FilterLayoutStyleProps) => props.fileTreeMaxHeight
		},
		showroomFilterTreeInnerWrapper: {
			paddingBottom: 20
		},
		showroomResultsContainer: {
			position: 'relative',
			marginTop: -7,
			flex: 1
		},
		refreshOverlay: {
			display: 'block',
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundColor: 'rgba(255,255,255, 0.7)',
			zIndex: 2,
			pointerEvents: 'none',
			opacity: 0,
			transition: 'opacity 0.2s'
		},
		refreshOverlayActive: {
			pointerEvents: 'all',
			opacity: 1,
			zIndex: 20
		}
	};
});
